export type PartnerUserDTO = {
  name: string;
  email: string;
  type: string;
  partnership_id: string;
};

export type PartnershipDTO = {
  name: string;
  partner_cut: number;
  logo?: File;
  infra_owner: PartnershipInfraOwner;
  user_name: string;
  user_email: string;
  partner_code: string;
};
export type PartnershipFormData = {
  name: string;
  partner_cut: string;
  logo: ImageForm;
  infra_owner: PartnershipInfraOwner;
  user_name: string;
  user_email: string;
  partner_code: string;
};
export enum PartnershipInfraOwner {
  greezon = 'greezon',
  partner = 'partner',
}
export type ImageForm = {
  id?: string;
  file?: File;
  base64?: string;
  src?: string;
};